import React from "react";
import { cn } from "@/lib/utils";

/**
 * Wordmark HTML/CSS "Le 11" — élégant serif italique sur fond sombre.
 *
 * Plus de PNG : on dessine le logo directement en HTML pour éviter les
 * artefacts du PNG d'origine (fond crème, lignes décoratives qui formaient
 * un cadre rectangulaire visible sur fond noir).
 *
 * Variantes :
 *   size:    sm | md | lg | xl | hero   — taille typographique
 *   tone:    light (ivoire/blanc) | accent (orange) — couleur principale
 *   tagline: bool — affiche "PIZZA · BURGER · SANDWICH" en sous-titre
 *   align:   center | start
 */

const sizeMap = {
  sm: "text-2xl sm:text-3xl",
  md: "text-3xl sm:text-4xl",
  lg: "text-5xl sm:text-6xl",
  xl: "text-6xl sm:text-7xl lg:text-8xl",
  hero: "text-[5.5rem] sm:text-[7rem] lg:text-[9.5rem] leading-[0.95]",
};

const taglineSizeMap = {
  sm: "text-[8px]",
  md: "text-[9px]",
  lg: "text-[11px]",
  xl: "text-xs sm:text-sm",
  hero: "text-xs sm:text-sm tracking-[0.42em]",
};

export const Logo = ({
  size = "md",
  tone = "light",
  tagline = false,
  align = "center",
  className,
}) => {
  const color =
    tone === "accent" ? "text-[#FF9500]" : "text-[#F5EFE6]"; // ivoire premium

  return (
    <div
      data-testid="brand-logo"
      className={cn(
        "inline-flex flex-col select-none",
        align === "center" ? "items-center text-center" : "items-start",
        className
      )}
    >
      <span
        className={cn("font-serif-brand leading-none", sizeMap[size], color)}
        aria-label="Le 11"
      >
        Le 11
      </span>
      {tagline && (
        <span
          className={cn(
            "mt-1.5 sm:mt-2 font-street uppercase",
            taglineSizeMap[size],
            tone === "accent" ? "text-[#FF9500]/80" : "text-[#F5EFE6]/65"
          )}
        >
          Pizza · Burger · Sandwich
        </span>
      )}
    </div>
  );
};

export default Logo;
